const eventTypeCarCoupon = (categoryCoupon, couponName, carModel, serviceType) => {
  if (typeof window !== 'undefined') {
    (window as any)?.dataLayer?.push({
      event: `generalEvent`,
      eventName: `${serviceType === 'coupon' ? 'kupon' : 'paket'}_servis_pilih_tipe_mobil_button`,
      eventCategory: `${serviceType === 'coupon' ? 'kupon' : 'paket'} servis page`,
      eventAction: `click on pilih tipe mobil`,
      eventLabel: `${categoryCoupon?.toLowerCase() || 'not available'} - ${couponName?.toLowerCase() || 'not available'} - pdp`,
      carModel: carModel?.toLowerCase() || 'not available',
    });
  }
};
export default eventTypeCarCoupon;
